<div class="dashboard-wrapper">
	<app-admin-header></app-admin-header>
    <div class="dashboard-container">
        <h6 class="welcome-title">Welcome back ,
       <ng-container *ngIf="userStore$ | async as userStore">
        {{ userStore.first_name }} {{userStore.last_name}}</ng-container>
		</h6>
        <p class="subtitle">Here's what's happening with your institution today</p>

		<ng-container *ngIf="isLoading; else pageContent">
			<div class="app-spinner">
			<mat-spinner diameter="60"></mat-spinner>
			</div>
		</ng-container>

		<ng-template #pageContent>
			<ng-container *ngIf="cardData.length > 0 ; else noUsersData">
        <div class="stats-grid">
            <div class="stat-card" *ngFor="let card of cardData">
                <div class="stat-content">
                    <div class="stat-text">
                        <p class="label">{{ card.title }}</p>
                        <h3 class="value">{{ card.value | number }}</h3>
                    </div>
                    <div class="stat-icon">
                        <mat-icon>{{ card.icon }}</mat-icon>
                    </div>
                </div>
            </div>
        </div>
		</ng-container>
		<ng-template #noUsersData>
			<p>no users found</p>
		</ng-template>
		</ng-template>
          <!-- we are using this later -->
        <!-- <div class="bottom-section">
            <div class="recent-activity">
                <h6>Recent Activity</h6>
                <div class="activity-list">
                    <div class="activity-item" *ngFor="let item of recentActivities">
                        <div class="activity-icon">{{ item.initials }}</div>
                        <div class="activity-content">
                            <p class="activity-title">{{ item.title }}</p>
                            <p class="activity-desc">{{ item.description }}</p>
                            <span class="time">{{ item.time }}</span>
                        </div>
                        <div class="activity-status">
                            <mat-icon *ngIf="item.status === 'completed'"
                                class="completed">check_circle_outline</mat-icon>
                            <mat-icon *ngIf="item.status === 'pending'" class="pending">schedule</mat-icon>
                        </div>
                    </div>
                </div>

            </div>

            <div class="quick-actions">
                <h3>Quick Actions</h3>
                <button mat-flat-button color="primary" *ngFor="let action of quickActions" (click)="action.handler()">
                    <mat-icon>{{ action.icon }}</mat-icon>
                    {{ action.label }}
                </button>
            </div>
        </div> -->
    </div>
</div>